import { t } from "@lingui/macro";
import * as React from "react";
import { Path, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const SnowIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Snow`} {...props}>
    <G clipPath="url(#a)">
      <Path
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.2}
        d="m14.727 11.05-1.625-.879 1.408-.778a.494.494 0 0 0 .193-.701.567.567 0 0 0-.747-.181l-1.94 1.072L9.092 8l2.924-1.583 1.94 1.072a.57.57 0 0 0 .747-.18.495.495 0 0 0-.193-.702l-1.408-.778 1.625-.88a.495.495 0 0 0 .2-.7.566.566 0 0 0-.746-.186l-1.625.88-.014-1.534c-.003-.282-.25-.51-.551-.507-.302.003-.544.234-.541.516l.02 2.112-2.924 1.583V3.947l1.96-1.039a.495.495 0 0 0 .207-.697.566.566 0 0 0-.744-.194l-1.423.754v-1.76C8.546.73 8.302.5 8 .5c-.301 0-.546.23-.546.512v1.76l-1.423-.755a.566.566 0 0 0-.744.194.495.495 0 0 0 .207.697l1.96 1.04v3.165L4.53 5.53l.02-2.112c.003-.282-.24-.513-.54-.516h-.006c-.299 0-.543.226-.546.507l-.014 1.533-1.625-.88a.566.566 0 0 0-.746.188.495.495 0 0 0 .2.7l1.625.879-1.408.778a.495.495 0 0 0-.193.701.572.572 0 0 0 .747.181l1.94-1.072L6.908 8 3.984 9.583l-1.94-1.072a.567.567 0 0 0-.747.18.494.494 0 0 0 .193.702l1.408.778-1.625.88a.495.495 0 0 0-.2.699.572.572 0 0 0 .746.187l1.625-.88.014 1.534c.003.28.247.507.546.507h.005c.302-.003.544-.234.541-.517l-.02-2.111 2.924-1.584v3.167l-1.96 1.039a.495.495 0 0 0-.207.697.572.572 0 0 0 .744.194l1.423-.754v1.76c0 .282.245.511.546.511.302 0 .546-.23.546-.512v-1.76l1.423.755a.572.572 0 0 0 .744-.194.495.495 0 0 0-.206-.697l-1.961-1.04V8.888l2.924 1.583-.02 2.111c-.003.283.239.514.54.517h.005c.3 0 .543-.226.546-.507l.015-1.533 1.625.88a.572.572 0 0 0 .746-.188.495.495 0 0 0-.2-.7Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
